<template>
  <Page subpage>
    <div class="flex justify-between items-center mb-4">
      <h3 class="page-header-2">Accounting Classes</h3>
      <div class="flex items-center">
        <SlotWrapper>
          <template #header>
            <Button
              type="secondary"
              class="mr-2 verify-button"
              data-cy="verify-accountingClasses"
              @click="beginVerifyingAccountingClasses()"
            >
              <div class="flex gap-2 items-center"><QBBall />Verify</div>
            </Button>
            <Button
              data-cy="new-accountingClass"
              @click="openAccountingClassModal()"
            >
              New
            </Button>
          </template>
        </SlotWrapper>
      </div>
    </div>
    <div class="datatable-report">
      <SlotWrapper>
        <template #body>
          <div class="datatable-v3">
            <table :class="['accounting-classes w-full']">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col" class="text-center">Status</th>
                </tr>
              </thead>
              <tbody>
            <tr
              v-for="accountingClass in accountingClasses"
              :key="accountingClass.id"
              class="accounting-class"
            >
                  <td class="name" data-cy="accountingClassName">
                    <ArchivedLabel
                      hide-archived-text
                      :disabled="!accountingClass.archived"
                    >
                      <span
                        class="link break-long-word"
                        @click="handleAccountingClassClick(accountingClass)"
                        >{{ accountingClass.name }}</span
                      >
                    </ArchivedLabel>
                  </td>
                  <td class="d-flex flex-column align-items-center">
                    <AccountingClassStatus
                      :status="accountingClass.qbo_status"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <AccountingClassModal
              v-if="isAccountingClassModalOpen"
              :accountingClass="currentAccountingClass"
              @hide-modal="toggleAccountingClassModal"
              @save-success="fetchAccountingClasses"
            />
          </div>
        </template>
      </SlotWrapper>
    </div>
  </Page>
</template>

<script>
import { mapActions, mapState } from "vuex";

import ArchivedLabel from "@/components/ArchivedLabel.vue";
import Button from "@/components/Button.vue";
import QBBall from "@/Quickbooks/QBBall.vue";
import Page from "../components/Page.vue";
import AccountingClassModal from "./AccountingClassModal.vue";
import AccountingClassStatus from "./AccountingClassStatus.vue";
import SlotWrapper from "@/components/SlotWrapper";

export default {
  components: {
    SlotWrapper,
    QBBall,
    ArchivedLabel,
    AccountingClassModal,
    AccountingClassStatus,
    Page,
    Button
  },
  data() {
    return {
      isAccountingClassModalOpen: false,
      currentAccountingClass: null
    };
  },
  computed: {
    ...mapState(["accountingClasses"])
  },
  watch: {
    isAccountingClassModalOpen(newValue, oldValue) {
      if (newValue !== oldValue && !newValue) {
        this.currentAccountingClass = null;
      }
    }
  },
  mounted() {
    if (Object.keys(this.accountingClasses).length === 0) {
      this.fetchAccountingClasses();
    }
  },
  methods: {
    ...mapActions(["fetchAccountingClasses", "verifyAccountingClasses"]),
    toggleAccountingClassModal() {
      this.isAccountingClassModalOpen = !this.isAccountingClassModalOpen;
    },
    openAccountingClassModal(accountingClass) {
      this.currentAccountingClass = accountingClass;
      this.toggleAccountingClassModal();
    },
    beginVerifyingAccountingClasses() {
      Object.values(this.accountingClasses).forEach((accountingClass) => {
        accountingClass.qbo_status = "verifying";
      });
      this.verifyAccountingClasses();
    },
    handleAccountingClassClick(accountingClass) {
      this.openAccountingClassModal(accountingClass);
    }
  }
};
</script>

<style lang="css" scoped>
.new-button {
  color: white;
}
</style>
